import React, { FunctionComponent, useLayoutEffect, useState } from 'react';
import { RecentlyViewed, RecentlyViewedItem, RecentlyViewedProduct } from '../../../../../generated/graphql';
import { recentlyViewedService } from '../../../../../services/recently-viewed-service';
import { clickEvent } from '../../../../../tagging/ensighten';
import { RecentlyViewedBrands } from './recently-viewed-brands/recently-viewed-brands-component';
import { RecentlyViewedCategories } from './recently-viewed-categories/recently-viewed-categories-component';
import { RecentlyViewedProducts } from './recently-viewed-products/recently-viewed-products-component';
import sharedStyles from './recently-viewed-shared.module.scss';

export type RecentlyViewedProps = {
  page: 'MyAccount' | 'Category' | 'PLP' | 'SRP' | 'PDP' | 'Basket';
  extraData?: string;
  removeMobilePadding?: boolean;
  removeMobileVerticalPadding?: boolean;
  className?: string;
};

export const RecentlyViewedComponent: FunctionComponent<RecentlyViewedProps> = (props: RecentlyViewedProps) => {
  const [data, setData] = useState<RecentlyViewed | undefined>(undefined);
  useLayoutEffect(() => {
    recentlyViewedService.getRecentlyViewedArea().then(setData);
  }, []);

  const labels = data?.labels;
  const recentlyViewedArea = data?.recentlyViewedArea;

  return (
    <>
      {(recentlyViewedArea?.products?.length || recentlyViewedArea?.categories?.length || recentlyViewedArea?.brands?.length) && (
        <div
          className={`${sharedStyles['recently-viewed-container']} ${
            props.removeMobilePadding ? sharedStyles['remove-mobile-padding'] : ''
          } ${props.className ?? ''} ${props.removeMobileVerticalPadding ? sharedStyles['remove-mobile-vertical-padding'] : ''}`}
          data-verbolia-id='recently-viewed-container'>
          {(recentlyViewedArea?.products?.length ?? 0) > 0 && (
            <RecentlyViewedProducts
              data={recentlyViewedArea?.products as RecentlyViewedProduct[]}
              onClickItemCallback={(product) => onClickProduct(product.stockCode)}
              labels={labels}
            />
          )}
          {(recentlyViewedArea?.categories?.length ?? 0) > 0 && (
            <RecentlyViewedCategories
              data={recentlyViewedArea?.categories as RecentlyViewedItem[]}
              onClickItemCallback={(cat) => onClickCategory(cat.url.text)}
              labels={labels}
            />
          )}
          {(recentlyViewedArea?.brands?.length ?? 0) > 0 && (
            <RecentlyViewedBrands
              data={recentlyViewedArea?.brands as RecentlyViewedItem[]}
              onClickItemCallback={(brand) => onClickBrand(brand.id)}
              labels={labels}
            />
          )}
        </div>
      )}
    </>
  );

  function onClickProduct(productId: string) {
    clickEvent({
      __Type: 'buttonTracker',
      __Info: `${props.page} RecentlyViewedProducts`,
      __Result: (props.extraData ? props.extraData + ',' : '') + productId,
    });
  }

  function onClickCategory(categoryId: string) {
    clickEvent({
      __Type: 'buttonTracker',
      __Info: `${props.page} RecentlyViewedCategory`,
      __Result: (props.extraData ? props.extraData + ',' : '') + categoryId,
    });
  }

  function onClickBrand(brandId: string) {
    clickEvent({
      __Type: 'buttonTracker',
      __Info: `${props.page} RecentlyViewedBrands`,
      __Result: (props.extraData ? props.extraData + ',' : '') + brandId,
    });
  }
};
